import { useMutation } from '@tanstack/react-query';
import { ILocationTag } from 'src/interfaces';
import { requestCCApi } from 'src/utils';

export const useCreateOwnerLocationTag = () => {
  return useMutation({
    mutationFn: createOwnerLocationTag,
  });
};

const createOwnerLocationTag = async (payload: Partial<ILocationTag>) => {
  const request = {
    name: payload.name?.trimEnd(),
  };

  const response = await requestCCApi({
    url: `/locationOwnerTags`,
    method: 'POST',
    data: { data: request },
  });

  return response;
};
